import { NormalText } from "@/components/text/NormalText";
import { Category } from "@/constants/selectArtistFilters";
import { useNamedSelectArtistFilters } from "@/lib/zustand/useSelectArtistFilters";
import { classNames } from "@/utils/classNames";

export function CategoryButton({
  text,
  namespace,
  value,
  Icon,
}: {
  namespace: string;
  text: string;
  value: Category;
  Icon: React.ForwardRefExoticComponent<
    Omit<React.SVGProps<SVGSVGElement>, "ref"> & {
      title?: string | undefined;
      titleId?: string | undefined;
    } & React.RefAttributes<SVGSVGElement>
  >;
}) {
  const useSelectArtistFilters = useNamedSelectArtistFilters((state) =>
    state.getNamedStore(namespace)
  );
  const setCategoryShow = useSelectArtistFilters(
    (state) => state.setCategoryShow
  );
  const categoryShow = useSelectArtistFilters((state) => state.categoryShow);

  const active = categoryShow === value;
  return (
    <li>
      <button
        className={classNames(
          active ? "border-b border-b-primary" : "",
          "flex items-center gap-x-2 py-1 transition-colors"
        )}
        onClick={() => setCategoryShow(value)}
      >
        <Icon
          className={classNames(
            active ? "text-primary" : "text-gray-400",
            "h-5 w-5 shrink-0 transition-colors"
          )}
        />

        <NormalText
          elementType="span"
          className={classNames(
            active ? "text-primary" : "text-gray-400",
            "whitespace-nowrap font-medium transition-colors"
          )}
        >
          {text}
        </NormalText>
      </button>
    </li>
  );
}
